import { useMemo } from "react";

import { COLORS, PROP_DEFINITIONS } from "./dioramaLayout";
import { InteractiveProp } from "./InteractiveProp";

const DEF = PROP_DEFINITIONS.find((p) => p.id === "calendar")!;

/** Visual-only calendar — reusable outside the engine's InteractiveProp wrapper. */
export function CalendarModel() {
  const days = useMemo(() => {
    const result: Array<{
      key: string;
      position: [number, number, number];
      color: string;
    }> = [];
    for (let row = 0; row < 4; row++) {
      for (let col = 0; col < 5; col++) {
        const isHighlighted = row === 2 && col === 3;
        result.push({
          key: `day_${row}_${col}`,
          position: [-0.35 + col * 0.18, 1.3 + row * 0.15, 0.15],
          color: isHighlighted ? COLORS.coral1 : "#CCCCCC",
        });
      }
    }
    return result;
  }, []);

  return (
    <group>
      {/* Post */}
      <mesh position={[0, 0.9, 0]} castShadow>
        <boxGeometry args={[0.15, 1.8, 0.15]} />
        <meshStandardMaterial color={COLORS.sandDark} flatShading />
      </mesh>

      {/* Calendar board */}
      <mesh position={[0, 1.6, 0.1]} castShadow>
        <boxGeometry args={[1.2, 1.0, 0.08]} />
        <meshStandardMaterial color={COLORS.cream} flatShading />
      </mesh>

      {/* Header */}
      <mesh position={[0, 2.0, 0.13]}>
        <boxGeometry args={[1.2, 0.25, 0.09]} />
        <meshStandardMaterial color={COLORS.coral2} flatShading />
      </mesh>

      {/* Day grid */}
      {days.map((day) => (
        <mesh key={day.key} position={day.position}>
          <boxGeometry args={[0.1, 0.1, 0.02]} />
          <meshStandardMaterial color={day.color} flatShading />
        </mesh>
      ))}

      {/* Decorative clip */}
      <mesh position={[0, 2.15, 0.1]} rotation={[Math.PI / 2, 0, 0]}>
        <cylinderGeometry args={[0.06, 0.06, 0.15, 6]} />
        <meshStandardMaterial color={COLORS.orange} flatShading />
      </mesh>
    </group>
  );
}

export function OfficeCalendar() {
  return (
    <InteractiveProp
      propId={DEF.id}
      label={DEF.label}
      clickMessage={DEF.clickMessage}
      position={DEF.position}
    >
      <CalendarModel />
    </InteractiveProp>
  );
}
